// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_gv","galleryThumbnail_active":"c-q_gw","galleryThumbnail__image":"c-q_gx"};